/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { QueryResponse } from '@app/core/types';
import { ClusterActionQueryResponseResult, QueryField } from '@shared/types/queries';
import { QueryField3x } from '@shared/types/queries-3x';
import { fromPairs } from 'lodash-es';

export const convertResponseRow = (responseResult: ClusterActionQueryResponseResult | QueryResponse) =>
  responseResult.rows.map((row) =>
    fromPairs(row.map((value, i) => [getResponseColumnId(responseResult.columns[i], i), value])),
  );

export const getResponseColumnId = (col: QueryField | QueryField3x | undefined, i: number) => {
  if (col?.typeName) {
    return `${col.typeName}.${col.fieldName}.${i}`;
  } else if (col?.fieldName) {
    return col.fieldName;
  } else {
    return i.toString(); // fieldName and typeName might miss from GG9 responses
  }
};
